import { ReactNode } from 'react';

import '../../stylesheets/_rerequisition-chip.scss';

import { IDraftOrder } from '@customTypes/draftOrder';
import { isMethylationReflexDraft, isReanalysisDraft } from '@helpers/draftOrder';

import { DraftOrderMethylationReanalysisChip } from './DraftOrderMethylationReanalysisChip';
import { DraftOrderReanalysisChip } from './DraftOrderReanalysisChip';

interface DraftOrderNameCellProps {
  draft: IDraftOrder;
  children: ReactNode;
}

export function DraftOrderNameCell({ draft, children }: DraftOrderNameCellProps) {
  return (
    <div className='d-flex align-items-center gap-2 flex-wrap'>
      {children}
      {isReanalysisDraft(draft) && <DraftOrderReanalysisChip />}
      {isMethylationReflexDraft(draft) && <DraftOrderMethylationReanalysisChip />}
    </div>
  );
}
